/** pay_types legado: objeto único; coluna payment_methods no backend é jsonb array. */
export function coercePayTypesObject(payTypes: unknown): Record<string, any> {
  if (payTypes == null) return {};
  if (typeof payTypes === "string") {
    try {
      return coercePayTypesObject(JSON.parse(payTypes));
    } catch {
      return {};
    }
  }
  if (Array.isArray(payTypes)) {
    const objects = payTypes.filter(
      (item) => item != null && typeof item === "object" && !Array.isArray(item)
    ) as Record<string, any>[];
    const withLogo = objects.find((item) => item.logo_public);
    if (withLogo) return withLogo;
    if (objects.length === 1) return objects[0];
    const withSettings = objects.find((item) => item.aceitas || item.store_manual_override);
    if (withSettings) return withSettings;
    return {};
  }
  if (typeof payTypes === "object") {
    return payTypes as Record<string, any>;
  }
  return {};
}

/** Formato aceito pelo backend em produção: array com um objeto. */
export function payTypesForApiUpdate(payTypes: Record<string, any>): Record<string, any>[] {
  return [payTypes];
}
